export default __webpack_public_path__ + "static/media/sa.6511ab2b.svg";